import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import membersService from "services/admin/membersService";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import rolesAdminService from "services/admin/rolesService";
import branchesAdminService from "services/admin/branchesService";
import categoriesAdminService from "services/admin/categoriesService";
import OperatorStations from "./OperatorStations";

const MemberForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { member, roles, branches, categories },
}) => {
  /**
   * Скорей всего нужно перевести данные о сотрудника в плоский формат
   */
  const fieldsWithData = [
    {
      key: "name",
      label: "ФИО(полностью как указан в удостоверение личности)",
      required: true,
      placeholder: 'Введите ФИО пользователя',
      inputType: inputTypeEnum.text,
    },
    {
      key: "user.email",
      label: "Email",
      inputType: inputTypeEnum.email,
    },
    {
      key: "user.phonePrefix",
      inputType: inputTypeEnum.hidden,
      defaultValue: 7,
    },
    {
      key: "user.phone",
      label: "Номер телефона",
      required: true,
      inputType: inputTypeEnum.phone,
      prefixKey: "user.phonePrefix",
    },
    {
      key: "user.password",
      label: "Пароль для входа (оставьте пустым, чтобы не менять)",
      inputType: inputTypeEnum.password,
      placeholder: "Минимум 6 символов",
    },
    // Филиал и тематику при создании не спрашиваем — их можно указать позже при редактировании
    ...(member
      ? [
          {
            key: "branchID",
            label: "Филиал",
            inputType: inputTypeEnum.select,
            options: branches ? branches.data : [],
            multiple: false,
          },
          {
            key: "categoryID",
            label: "Тематика обращения",
            inputType: inputTypeEnum.select,
            options: categories ? categories.data : [],
            multiple: false,
          },
        ]
      : []),
    {
      key: "roleID",
      label: "Роли",
      inputType: inputTypeEnum.select,
      options: roles,
      multiple: false,
      required: true
    },
    {
      key: "canProcessOrder",
      label: "Автоматически назначать менеджером для новых заказов",
      inputType: inputTypeEnum.checkbox,
    },
  ];

  const onSubmit = async (formInput) => {
    try {
      if (member) {
        await membersService.put(id, formInput)
        snack("Сотрудник обновлен успешно!");
      } else {
        await membersService.post(formInput)
        snack("Сотрудник создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 1000);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={member ? 'Редактирование сотрудника' : 'Создание сотрудника'}>
      <AppForm onSubmit={onSubmit} data={member} fields={fieldsWithData}></AppForm>
      {member && id && <OperatorStations memberID={id} />}
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(MemberForm, (router) => {
    let requests = {
      roles: rolesAdminService.getAll,
    }
    if (router.params.id) {
      requests['member'] = () => membersService.get(router.params.id)
      // Филиалы и тематики нужны только при редактировании
      requests['branches'] = branchesAdminService.getAll
      requests['categories'] = () => categoriesAdminService.getAll({ type: 'TICKET' })
    }
    return useLoadAll(requests);
  })
);
